import { css } from 'styled-components';
import { getThemeData } from '@hzero-front-ui/core';
var AutCompleteStyle = function AutCompleteStyle(props) {
  var _getThemeData = getThemeData(props, 'common'),
    primary6 = _getThemeData.primary6,
    primary1 = _getThemeData.primary1;
  return css([".c7n-pro-auto-complete-dropdown-menu.c7n-pro-auto-complete-dropdown-menu{.c7n-pro-auto-complete-dropdown-menu-item{margin:0rem 0.08rem;padding:0.04rem 0.06rem;&.c7n-pro-auto-complete-dropdown-menu-item-active{background:", ";border-radius:0.02rem;color:", ";}}}"], primary1, primary6);
};
export default AutCompleteStyle;